<template>
	<form-field-wrap
			:field-props="fieldProps"
			:is-error="isError"
			:field-value="fieldValue"
			:is-switch="isSwitch"
			:input-focus="inputFocus"
			:with-label="false"
	>
		<template>
			<citrus-html-editor
					v-if="fieldProps.TYPE == 'html'"
					ref="field"
					:height="height"
					:min-height="minHeight"
					:max-height="maxHeight"
					:placeholder="fieldProps.PLACEHOLDER ? fieldProps.PLACEHOLDER : fieldProps.TITLE"
					:show-preview="false"
					:_model="fieldValue"
					:language="'ru-RU'"
					@changed="onHtmlChangeValue"
					@focus="labelSwitch('focus')"
					@blur="labelSwitch"
					v-validate="rules"
					v-model="fieldValue"
					:data-vv-as="fieldProps.TITLE"
					:name="fieldProps.CODE"
			></citrus-html-editor>
		</template>
	</form-field-wrap>
</template>
<script>
	import "citrus.vue.editor";

	export default {
		name: "FormFieldHtml",
		props: {
			height: {
				type: Number,
				default: 300
			},
			minHeight: {
				type: Number,
				default: 160
			},
			maxHeight: {
				type: Number,
				default: 300
			},
		},
		methods: {
			onHtmlChangeValue: function (newValue) {
				this.inputValue = newValue;
				this.$emit('input', newValue);
			},
		}
	}
</script>
<style>
	.form-field_error .note-placeholder {
		display: none !important;
	}
</style>